import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { User } from '../../resources/models/user.model';
import { ClientService } from '../../services/client/client.service';

@Component({
  selector: 'enrich-client-layout',
  templateUrl: './client-layout.component.html',
  styleUrls: ['./client-layout.component.sass'],
})
export class ClientLayoutComponent {
  user: User;

  constructor(
    private route: ActivatedRoute,
    private clientService: ClientService,
  ) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.clientService.updateCustomer(params['customerName']);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/layouts/client/client-layout.component.ts